// extracted by mini-css-extract-plugin
module.exports = {"default":"no-result_default__20naI"};